module.exports = __webpack_public_path__ + "static/media/banner-photo526.bf44812b.webp";